import "./scss/style.scss";
import gsap from "gsap";
import Experience from "./class/Experience.js";

const experience = new Experience(document.querySelector("canvas.webgl"))

function closePopup() {
    gsap.to(".popup", {
        opacity: 0,
        display: "none",
        zIndex: -1
    })
}
closePopupMention.addEventListener("click", () => {
    closePopup()
})


closePopupInfo.addEventListener("click", () => {
    closePopup()
})
closePopupContact.addEventListener("click", () => {
    closePopup()
})
openPopupContact.addEventListener("click", () => {
    gsap.to(popupInfo, {
        opacity: 1,
        display: "flex",
        zIndex: 50
    })
})
openPopupInfo.addEventListener("click", () => {
    gsap.to(popupContact, {
        opacity: 1,
        display: "flex",
        zIndex: 50
    })
})
openPopupMention.addEventListener("click", () => {
    gsap.to(popupMention, {
        opacity: 1,
        display: "flex",
        zIndex: 50
    })
})